import React, { useState, useEffect } from 'react';
import { Select, Spin } from 'antd';
import axiosInstance from '../../api/axiosInstance';
import useDebounce from '../../hooks/useDebounce';
import useAuthStore from '../../store/useAuthStore';

const SearchableSelect = ({ 
  apiUrl, valueField = 'id', labelField = 'name', 
  onSelect, placeholder = 'Search...', value, 
  disabled = false, extraParams = {}, renderLabel 
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const { user } = useAuthStore();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const params = {
          search: debouncedSearchTerm,
          plantId: user?.plantID,
          ...extraParams
        };
        // Use 'q' for quick search endpoints if needed, handling automatically
        if (apiUrl.includes('/search')) {
            params.q = debouncedSearchTerm;
        }

        const response = await axiosInstance.get(apiUrl, { params });
        // Handle both direct array and paginated response { items: [...] }
        const resultData = response.items || response; 
        setData(Array.isArray(resultData) ? resultData : []);
      } catch (error) {
        console.error("Error fetching select data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [debouncedSearchTerm, apiUrl, user?.plantID, JSON.stringify(extraParams)]);

  const handleChange = (selectedValue) => {
    if (selectedValue === undefined || selectedValue === null) {
      if (onSelect) onSelect(null);
      return;
    }
    const selectedObject = data.find(item => item[valueField] === selectedValue);
    if (onSelect && selectedObject) {
      onSelect(selectedObject);
    }
  };

  return (
    <Select
      showSearch
      allowClear
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      filterOption={false}
      onSearch={setSearchTerm}
      onChange={handleChange}
      notFoundContent={loading ? <Spin size="small" /> : null}
      style={{ width: '100%' }}
    >
      {data.map((item) => (
        <Select.Option key={item[valueField]} value={item[valueField]}>
          {renderLabel ? renderLabel(item) : item[labelField]}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SearchableSelect;